import { useModal } from "hooks/useModal"
import { useAppDispatch } from "reducers/store"

import styled from "styled-components"
import { useCallback, memo } from "react"
import IconEdit from "components/EvtKit/icons/IconEdit"
import { setInvoice } from "reducers/invoice/invoice-actions"

const InlineButton = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 16px;
`

interface UpdateInvoiceButtonProps {
  invoice: App.InvoiceParams
}

const EditAccountButton = (props: UpdateInvoiceButtonProps) => {
  const { invoice } = props

  const appDispatch = useAppDispatch()

  const { openModal } = useModal()

  const handleOnClick = useCallback(async () => {
    appDispatch(setInvoice(invoice))
    openModal("update")
  }, [invoice])

  return (
    <InlineButton onClick={handleOnClick}>
      <IconEdit />
    </InlineButton>
  )
}

export default memo(EditAccountButton)
